define('views/components/store_product/store_product',['require','backbone','models/basket_product','text!templates/components/store_product/store_product.html'],function(require){

    var Backbone = require('backbone');


    var BasketProductModel = require('models/basket_product');

    var temp = require("text!templates/components/store_product/store_product.html");
    return Backbone.Marionette.ItemView.extend({
        tagName: 'div',
        template: _.template(temp),
        className: 'gallery-item',
        attributes: function() {
            var product_image = this.model.get("product_image");
            return {
              "data-width": product_image.image_width,
              "data-height": product_image.image_height,
              "id":this.model.get("name")
            };
          },

        ui: function() {
            return {
                descriptionField: '.product-description',
                addToBasketButton: '.add-to-basket-button',
                countField: '#item_count',
            };
        },

        events: {
            'click @ui.addToBasketButton': 'addToBasketButtonClicked',
        },

        onRender: function () {
            this.ui.descriptionField.scrollbar();
        },

        templateHelpers: function(){
            return {
                currencySign: App.utils.getProductCurrency(this.model.get('exchange_currency')),
                product_image : this.model.get("product_image").image
            };
        },

        addToBasketButtonClicked: function () {
            var _this = this;

            if (this.ui.countField.val() > 0) {
                var currentBasketProduct = App.context.basket.get('products').filter(function (basketProduct) {
                    return basketProduct.product.id == _this.model.get('id') && !basketProduct.license;
                })[0];

                if (currentBasketProduct) {
                    // Product already in basket, if customer context and license type is single, prevent update, else
                    // update count
                    if (( (!App.user || App.user.get('customer')) && currentBasketProduct.product.license_type == 1)) {
                        return;
                    }

                    currentBasketProduct.count += parseInt(this.ui.countField.val());
                } else {
                    // Product not in basket, create new entry
                    var basketProduct = new BasketProductModel({
                        product: this.model.attributes,
                        count: parseInt(this.ui.countField.val())
                    });

                    App.context.basket.get('products').push(basketProduct.attributes);
                }

                App.vent.trigger('basket-updated');
            } else {
                // Invalid count entered
                App.utils.showMessage('warning', App.polyglot.t('invalid_product_count'));
            }
        }, 


    });
});
